import { SiteUrls } from '@tableau/shared-urls';
import { IUserNotification } from '@tableau/user-notifications-client-core';

import { Messages } from '../../../codegen/Localize';
import { Location } from '../../../common/react/Location';
import { NotificationMenuItem } from '../IUserNotificationMenuItemProvider';
import { UserNotificationMenuItemDefaultProvider } from '../UserNotificationMenuItemDefaultProvider';

export type ExtractNotificationContent = {
  workbookCount: number;
  dataConnectionId: string;
  workbookId: string;
  workbookName: string;
  datasourceName: string;
  lastSuccessTime: number;
  lookBackDays: number;
  statusCodeId: number;
  failureThreshold: number;
  consecutiveFailureCount: number;
};

export class ExtractMenuItemProvider extends UserNotificationMenuItemDefaultProvider<ExtractNotificationContent> {

  public getNotificationMenuItems(notification: IUserNotification<ExtractNotificationContent>, siteUrls: SiteUrls): Array<NotificationMenuItem> {
    let defaultItems = super.getNotificationMenuItems(notification);
    let url = '';
    if (notification.content.dataConnectionId) {
      url = siteUrls.datasourceDataConnectionUrl(notification.content.dataConnectionId);
    } else {
      url = siteUrls.workbookDatasourcesUrl(notification.content.workbookId);
    }

    defaultItems.push({
      title: Messages.connectionDetails(),
      testId: 'ConnectionDetail-' + notification.id,
      closePanel: true,
      onClick: () => {
        if (!notification.read) {
          this.userNotificationActions.updateUserNotificationsStatus([notification.id], true);
        }
        Location.instance.setUrl(url);
      }
    });
    return defaultItems;
  }
}